module.exports = __webpack_public_path__ + "img/slotmachine.d9511d3d.png";